<template>
  <div :class="'custom_input'">
    <input
      id="upload"
      accept="image/*"
      class="input"
      style="display: none;"
      type="file"
      @change="convertToBase64()"
    >
    <label
      class="btn btn_md primary_btn"
      for="upload"
    ><span class="p_body font_bold">{{
      capitalisedLabel
    }}</span></label>
    <small
      v-for="(error, index) in validationErrors"
      :key="index"
      class="validation"
    >{{ error }}</small>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  props: {
    label: {
      type: String,
      default: 'Select file'
    },
    modelValue: {
      type: String,
      default: '',
    },
    validationErrors: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    capitalisedLabel() {
      let words = this.label.split(' ');
      _.each(words, (word, index) => {
        words[index] = _.capitalize(word);
      });
      return words.join(' ');
    }
  },
  methods: {
    convertToBase64() {
      let file = document.querySelector('#upload')['files'][0];
      let reader = new FileReader();
      let baseString;
      let self = this;
      reader.onloadend = function () {
        baseString = reader.result;
        self.$emit('update:modelValue', baseString);
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>
<style scoped>
.custom_input {
  margin-bottom: 1.5rem;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.full {
  width: 100%;
}

.two-thirds {
  width: calc(66.66% - .5rem);
}

.half {
  width: calc(50% - .5rem);
}

.third {
  width: calc(33.33% - .5rem);
}

.quarter {
  width: calc(25% - .5rem);
}

.input {
  width: 100%;
}

.btn {
  margin-bottom: 0;
}

.label {
  margin-bottom: .25rem;
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
}

.validation {
  text-align: center;
  color: red;
  margin-left: 10px;
}
</style>
